module.exports = __webpack_public_path__ + "img/user-01.22e5a823.jpg";